

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
  @Prop({ required: false, default: true }) public closeOutside: boolean;
  @Prop({ required: false, default: true }) public showCancel: boolean;

  private emitOutsideClick() {
    if (this.closeOutside) {
      this.$emit("close");
    }
  }
}
